import type { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const buttonComponentDefinition: ComponentDefinition = {
    id: 'button-display',
    name: 'Button',
    category: 'Custom Components',
    variables: {
        text: {
            displayName: 'Label',
            type: 'Text',
            defaultValue: 'Click me',
        },
        buttonType: {
            displayName: 'Button Type',
            type: 'Text',
            defaultValue: 'solid',
            group: 'style',
            validations: {
                in: [
                    { displayName: 'Solid', value: 'solid' },
                    { displayName: 'Outline Dark', value: 'outline-dark' },
                    { displayName: 'Outline White', value: 'outline-white' },
                ],
            },
        },
        linkSlug: {
            displayName: 'Link Slug',
            type: 'Text',
            description: 'Link to a page',
            validations: {
                bindingSourceType: ['entry'],
            },
        },
        pageType: {
            displayName: 'Page Type',
            type: 'Text',
            defaultValue: 'solid',
            description: 'Required if link slug is provided',
            group: 'content',
            validations: {
                bindingSourceType: ['manual'],
                in: [
                    { displayName: 'Choose', value: '' },
                    { displayName: 'Landing', value: 'pageLanding' },
                    { displayName: 'Company', value: 'pageCompany' },
                    { displayName: 'Industry', value: 'pageIndustry' },
                    { displayName: 'Service', value: 'pageService' },
                    { displayName: 'Person', value: 'pagePerson' },
                    { displayName: 'Case Study', value: 'pageCaseStudy' },
                    { displayName: 'Journal', value: 'pageJournal' },
                    { displayName: 'Technology', value: 'pageTechnology' },
                ],
            },
        },
        linkPath: {
            displayName: 'Link Path',
            type: 'Text',
            description: 'Manually set link path (external page or anchor)',
            validations: {
                bindingSourceType: ['manual'],
            },
        },
    },
};
